import styled from 'styled-components';
import { Container } from '../../../../../stories/atoms';

export const StyledSection = styled(Container)`
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundSelectedHover : color.backgroundTableHeader};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
  flex: 1;
`;
